import RestAPIClient from "services/RestAPIClient";
import {
  IBiz,
  IRequestChannelPerm,
  IReqRegisterChannelPerm,
  IChannelPerm,
} from "./typings";

class chatService extends RestAPIClient {
  constructor() {
    super("chats");
  }

  getBizs = async (): Promise<IBiz[]> => {
    const res = await this.get(`/biz`);
    return res.data;
  };

  getChannelPerm = async (req: IRequestChannelPerm): Promise<IChannelPerm> => {
    const res = await this.get(`/channel-perm`, req);
    return res.data;
  };

  registerChannelPerm = async (
    req: IReqRegisterChannelPerm
  ): Promise<any[]> => {
    const res = await this.post("/channel-perm/register", req);
    return res.data;
  };

  getBizManagement = async (): Promise<any[]> => {
    const res = await this.get(`/me/biz-management `);
    return res.data;
  };
}

export default new chatService();
